import { createApp } from 'vue';
import { createPinia } from 'pinia';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './styles/hacker.scss';

import App from './App.vue';
import { router } from './router';
import { useGameStore } from './stores/game';

const app = createApp(App);
app.use(createPinia());
app.use(router);

// When the api layer exhausts the refresh token, it dispatches this event.
// We route the user back to /login with a `redirect` query so they return
// to whatever they were doing after re-auth.
window.addEventListener('netrunner:session-expired', () => {
  const current = router.currentRoute.value.fullPath;
  if (current !== '/login') {
    router.replace({ name: 'login', query: { redirect: current } });
  }
});

// If a token is already in localStorage (e.g. after a hard reload), restore
// the user profile from the backend before the router resolves the first
// navigation, so the guard sees a consistent state and doesn't bounce the
// user to /login.
const game = useGameStore();
game.restoreSession().finally(() => {
  app.mount('#app');
});
